import React from 'react'
import { Spinner } from 'react-bootstrap'

function LoadingMessage() {
  return (
    <div>
      <div className="d-flex justify-content-center align-items-center spinner-container">
        <Spinner animation="border" variant="primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
        <span className="ms-2">Please Wait...</span>
      </div>
    </div>
  )
}

export default LoadingMessage
